<div class="modal-root-mobile-full">
  @if (data.isFromGuide) {
    <app-task-info-tooltips
      [taskTitle]="'addManualAccount'"
      [taskDescription]="'accountCreated'"
      [subTaskDescription]="'accountCreatedDetails'"
      [guideTitle]="'addManualAccount'"
      [bottomAction]="'none'"
      [tooltipLayout]="'overlayRight'"
      [currentStep]="ManualAccountGuideSteps.setBalance"
      [totalSteps]="ManualAccountGuideTotalSteps"
    ></app-task-info-tooltips>
  }
  <modal-header [showBackButton]="false" [title]="balanceForm.title"></modal-header>
  <div class="modal-body" [ngClass]="data.isFromGuide ? 'guide-modal-safe-area' : ''">
    <form [formGroup]="balanceForm.formGroup" name="accountForm">
      <div class="tw-mb-6 tw-flex tw-flex-col tw-gap-6">
        <!-- Balance Type segmented toggle -->
        <div class="tw-flex tw-flex-col tw-gap-1">
          <span class="tw-text-[13px] sm:tw-text-[12px] tw-font-bold tw-text-dt-text-tertiary">
            {{ "balanceType" | i18n }}
          </span>
          <div
            class="tw-flex tw-w-full tw-h-[48px] tw-items-center tw-rounded-2xl tw-bg-dt-surface-card tw-p-1 tw-shadow-neuomorphic-raised-strong"
          >
            @for (balanceOption of balanceForm.balances; track balanceOption.value) {
              <button
                type="button"
                (click)="balanceForm.selectBalance(balanceOption.value)"
                class="tw-flex tw-h-full tw-flex-1 tw-items-center tw-justify-center tw-rounded-xl tw-border-0 tw-cursor-pointer tw-transition-all tw-duration-200"
                [ngClass]="
                  balanceForm.selectedBalance === balanceOption.value
                    ? 'tw-bg-dt-surface-card tw-shadow-neuomorphic-inset'
                    : 'tw-bg-transparent'
                "
              >
                <span
                  class="tw-font-medium tw-text-[14px] tw-tracking-[0.005em]"
                  [ngClass]="
                    balanceForm.selectedBalance === balanceOption.value
                      ? 'tw-text-dt-text-action'
                      : 'tw-text-dt-text-secondary'
                  "
                >
                  {{ balanceOption.label }}
                </span>
              </button>
            }
          </div>
        </div>

        <div class="tw-flex tw-justify-between tw-gap-4 sm:tw-gap-6 tw-w-full">
          <!-- Date picker: neumorphic trigger + app-calendar (single date) in a CDK overlay -->
          <div class="tw-flex tw-w-1/2 xs:tw-w-full tw-flex-col tw-gap-1">
            <span class="tw-text-[13px] sm:tw-text-[12px] tw-font-bold tw-text-dt-text-tertiary">
              {{ balanceForm.i18nService.t("date")
              }}<span class="tw-text-dt-text-tertiary"> *</span>
            </span>
            <app-date-field
              [displayText]="dateText"
              [dateFilter]="dateFilter"
              [isInvalid]="
                balanceForm.formGroup.get('date').invalid &&
                balanceForm.formGroup.get('date').touched
              "
              (dateChange)="onDatePicked($event)"
            ></app-date-field>
          </div>
        </div>
        <div class="tw-flex sm:tw-flex-col tw-gap-4 sm:tw-gap-6 tw-w-full">
          @if (bankOrCredit()) {
            <app-input
              [label]="balanceFieldLabel"
              [isRequired]="true"
              [type]="InputTypes.number"
              [value]="balanceForm.formGroup.get('balance')?.value"
              (outputValue)="balanceForm.onInput($event, 'balance')"
              class="tw-w-1/2 sm:tw-w-full"
              [isDisabled]="false"
              [manualTouched]="balanceForm.formGroup.controls.balance.touched"
            >
            </app-input>
            <app-currencies
              [disabled]="true"
              (onSelectCurrency)="balanceForm.selectCurrency($event)"
              [label]="currencyFieldLabel"
              [defaultCurrency]="data?.accountView?.currency"
              [detachPanel]="true"
              class="tw-w-1/2 sm:tw-w-full"
            ></app-currencies>
          } @else {
            <div class="tw-flex tw-flex-col tw-w-1/2 sm:tw-w-full">
              <app-dropdown-select
                [isEnabled]="true"
                (optionSelected)="balanceForm.selectCurrency($event)"
                [options]="symbolOptions()"
                [selectedOption]="balanceForm.currency"
                [label]="currencyFieldLabel"
                [customShadowClass]="'tw-shadow-dropdown'"
                [showGradientBorder]="false"
                [detachPanel]="true"
                class="tw-w-full"
              >
              </app-dropdown-select>
              <button
                type="button"
                class="tw-text-sm tw-text-dt-text-secondary tw-underline tw-w-full tw-bg-transparent tw-border-0 tw-p-0 tw-text-left"
                (click)="openAddSymbolDialog()"
              >
                {{ "symbolNotFound" | i18n }}
              </button>
            </div>
            <app-input
              [label]="balanceFieldLabel"
              [isRequired]="true"
              [type]="InputTypes.number"
              [value]="balanceForm.formGroup.get('balance')?.value"
              (outputValue)="balanceForm.onInput($event, 'balance')"
              class="tw-w-1/2 sm:tw-w-full"
              [isDisabled]="false"
              [manualTouched]="balanceForm.formGroup.controls.balance.touched"
            >
            </app-input>
          }
        </div>
        <app-input
          [label]="'description' | i18n"
          [placeholder]="'description' | i18n"
          [multiline]="true"
          [value]="balanceForm.formGroup.get('description')?.value"
          (outputValue)="balanceForm.onInput($event, 'description')"
          class="tw-w-full"
        >
        </app-input>
      </div>
      <button
        type="button"
        (click)="submit()"
        [attr.aria-busy]="submitting || null"
        class="tw-flex tw-w-full tw-items-center tw-justify-center tw-rounded-[50px] tw-bg-dt-surface-on-action tw-px-6 tw-py-4 tw-shadow-button-shadow"
      >
        <span
          class="tw-font-medium tw-text-[20px] sm:tw-text-[18px] tw-tracking-[0.005em] tw-leading-[135%] tw-text-dt-slate-0 tw-whitespace-nowrap"
          >{{ "save" | i18n }}</span
        >
      </button>
    </form>
  </div>
</div>
